import React, { useState } from 'react'
import '../home.css';
import SEO from '../SEO.js';

const EFFICIENTNET_SERIES = [
    { label: 'B0', params: 5.3, acc: 77.1, labelOffset: { dx: -14, dy: 2 } },
    { label: 'B1', params: 7.8, acc: 79.1, labelOffset: { dx: -14, dy: 2 } },
    { label: 'B2', params: 9.2, acc: 80.1, labelOffset: { dx: -14, dy: 2 } },
    { label: 'B3', params: 12, acc: 81.6, labelOffset: { dx: -14, dy: 2 } },
    { label: 'B4', params: 19, acc: 82.9, labelOffset: { dx: 4, dy: -10 } },
    { label: 'B5', params: 30, acc: 83.6 },
    { label: 'B6', params: 43, acc: 84.0 },
    { label: 'B7', params: 66, acc: 84.3, labelOffset: { dx: 6, dy: -6 } },
];

const NAS_SERIES = [
    { key: 'nasnet-bottom', label: 'NASNet-A', params: 5.3, acc: 74.0, labelOffset: { dx: 0, dy: 16 } },
    { key: 'nasnet-small', label: null, params: 10, acc: 78.5 },
    { key: 'amoebanet-a', label: 'AmoebaNet-A', params: 88, acc: 82.8, labelOffset: { dx: -12, dy: -10 } },
    { key: 'nasnet-large', label: 'NASNet-A', params: 89, acc: 82.7, labelOffset: { dx: 14, dy: 14 } },
    { key: 'amoebanet-c', label: 'AmoebaNet-C', params: 155, acc: 83.5, labelOffset: { dx: -6, dy: -10 } },
];

const RESNET_SERIES = [
    { key: 'inception-v2', label: 'Inception-v2', params: 11.2, acc: 74.8, labelOffset: { dx: 38, dy: 2 } },
    { key: 'densenet-201', label: 'DenseNet-201', params: 20, acc: 77.4, labelOffset: { dx: 48, dy: 2 } },
    { key: 'xception', label: 'Xception', params: 22.8, acc: 79.0, labelOffset: { dx: 24, dy: 20 } },
    { key: 'inception-resnet-v2', label: 'Inception-ResNet-v2', params: 55, acc: 80.1, labelOffset: { dx: 20, dy: 18 } },
    { key: 'resnext-101', label: 'ResNeXt-101', params: 84, acc: 80.9, labelOffset: { dx: 0, dy: 16 } },
    { key: 'senet', label: 'SENet', params: 146, acc: 82.7, labelOffset: { dx: 0, dy: 16 } },
];

const STANDALONE_MODELS = [
    { key: 'resnet-34', label: 'ResNet-34', params: 21.8, acc: 73.3, labelOffset: { dx: 8, dy: 16 } },
    { key: 'resnet-50', label: 'ResNet-50', params: 25.6, acc: 76.3, labelOffset: { dx: 22, dy: 16 } },
    { key: 'resnet-152', label: 'ResNet-152', params: 60, acc: 77.8, labelOffset: { dx: 24, dy: 16 } },
];

const MISCLASSIFICATION_BY_ALTERATION = [
    { label: 'Compression', rate: 26.30 },
    { label: 'AI BPPs', rate: 23.80 },
    { label: 'Super Resolution', rate: 25.76 },
    { label: 'Resize', rate: 25.10 },
    { label: 'Central Crop', rate: 25.92 },
    { label: 'Brightness Increase', rate: 25.28 },
    { label: 'Contrast Increase', rate: 26.55 },
    { label: 'Blurring', rate: 25.92 },
    { label: 'Greyscale', rate: 29.72 },
    { label: 'Rotation', rate: 25.00 },
];

const CLASSIFICATION_BY_TRAINING = [
    { training: '20K Non-distorted', alterations: 1, rate: 91.34 },
    { training: '20K Non-distorted', alterations: 2, rate: 83.21 },
    { training: '20K Non-distorted', alterations: 3, rate: 73.92 },
    { training: '20K Non-distorted + 10K Step 1', alterations: 3, rate: 94.73 },
];

const GENERATORS = [
    'Adobe Firefly', 'Dall-E 1', 'Dall-E 3', 'Deep AI', 'Flux.1', 'Flux.1.1 Pro', 'Freepik',
    'Hotpot AI', 'Leonardo AI', 'Midjourney', 'Nvidia Sana PAG', 'Stable Cascade',
    'Stable Diffusion 3.5', 'Stable Diffusion Attend and Excite', 'Stable Diffusion XL',
    'Starry AI', 'StyleGAN', 'StyleGAN2', 'StyleGAN3', 'Tencent Hunyuan',
];

const CONFUSION_MATRIX = [
    [0, 0, 1, 6, 1, 0, 1, 17, 1, 2, 0, 2, 1, 2, 18, 23, 0, 0, 0, 0],
    [1, 0, 0, 7, 0, 0, 2, 0, 0, 2, 0, 2, 0, 3, 52, 6, 4, 0, 13, 1],
    [9, 0, 0, 40, 4, 0, 16, 18, 0, 1, 2, 49, 9, 3, 5, 9, 0, 0, 0, 3],
    [1, 0, 0, 0, 2, 0, 20, 7, 0, 1, 0, 11, 1, 1, 26, 14, 0, 0, 0, 0],
    [1, 0, 0, 35, 0, 0, 9, 3, 0, 0, 2, 35, 4, 0, 6, 2, 0, 0, 0, 2],
    [3, 0, 0, 80, 11, 0, 13, 2, 0, 18, 0, 5, 2, 0, 34, 21, 0, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 4, 2, 0, 0, 0, 0],
    [5, 0, 0, 20, 6, 1, 42, 0, 0, 1, 0, 1, 4, 0, 76, 46, 0, 0, 0, 0],
    [38, 1, 0, 13, 2, 3, 7, 25, 0, 32, 0, 7, 11, 1, 31, 134, 0, 1, 0, 2],
    [19, 2, 3, 25, 7, 6, 4, 12, 3, 0, 0, 25, 7, 4, 39, 19, 0, 0, 0, 1],
    [7, 0, 8, 9, 62, 0, 11, 1, 0, 2, 0, 71, 13, 0, 3, 6, 0, 0, 0, 11],
    [1, 0, 0, 15, 0, 1, 10, 2, 0, 0, 0, 0, 1, 0, 21, 8, 0, 0, 0, 0],
    [6, 0, 0, 4, 7, 0, 11, 8, 0, 1, 0, 19, 0, 0, 10, 8, 0, 0, 0, 0],
    [10, 1, 1, 9, 2, 1, 6, 2, 0, 2, 0, 2, 1, 0, 52, 42, 0, 0, 2, 1],
    [3, 2, 0, 8, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 6, 0, 0, 0, 0],
    [3, 1, 0, 6, 1, 0, 0, 18, 0, 0, 0, 2, 0, 3, 37, 0, 0, 0, 0, 0],
    [0, 3, 0, 1, 0, 0, 0, 1, 0, 3, 0, 0, 0, 1, 39, 16, 0, 52, 46, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 59, 17, 2, 0, 30, 0],
    [0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 68, 5, 1, 29, 0, 0],
    [24, 0, 4, 26, 13, 2, 42, 3, 0, 9, 8, 118, 5, 0, 8, 1, 0, 0, 0, 0],
];

const haloProps = { paintOrder: 'stroke', stroke: '#fff', strokeWidth: 3, strokeLinejoin: 'round' };

const EfficientNetChart = () => {
    const width = 780, height = 480;
    const margin = { top: 20, right: 20, bottom: 56, left: 56 };
    const plotW = width - margin.left - margin.right;
    const plotH = height - margin.top - margin.bottom;

    const xMax = 180, yMin = 72, yMax = 85;
    const sx = (params) => margin.left + (params / xMax) * plotW;
    const sy = (acc) => margin.top + plotH - ((acc - yMin) / (yMax - yMin)) * plotH;

    const xTicks = [0, 20, 40, 60, 80, 100, 120, 140, 160, 180];
    const yTicks = [74, 76, 78, 80, 82, 84];

    const linePath = (series) => series.map((p, i) => `${i === 0 ? 'M' : 'L'} ${sx(p.params)} ${sy(p.acc)}`).join(' ');

    const renderPoints = (series, { fill, textFill, fontSize, fontWeight, radius, defaultDy }) => (
        series.map(p => (
            <g key={p.key ?? p.label}>
                <circle cx={sx(p.params)} cy={sy(p.acc)} r={radius} fill={fill} />
                {p.label && (
                    <text
                        {...haloProps}
                        x={sx(p.params) + (p.labelOffset?.dx ?? 0)}
                        y={sy(p.acc) + (p.labelOffset?.dy ?? defaultDy)}
                        textAnchor="middle"
                        fontSize={fontSize}
                        fontWeight={fontWeight}
                        fill={textFill}
                    >
                        {p.label}
                    </text>
                )}
            </g>
        ))
    );

    return (
        <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-auto font-raleway">
            {yTicks.map(t => (
                <g key={`y-${t}`}>
                    <line x1={margin.left} x2={width - margin.right} y1={sy(t)} y2={sy(t)} stroke="#e7e5e4" strokeWidth="1" />
                    <text x={margin.left - 10} y={sy(t)} textAnchor="end" dominantBaseline="middle" fontSize="11" fill="#78716c">{t}</text>
                </g>
            ))}
            {xTicks.map(t => (
                <text key={`x-${t}`} x={sx(t)} y={height - margin.bottom + 20} textAnchor="middle" fontSize="11" fill="#78716c">{t}</text>
            ))}
            <text x={margin.left - 40} y={margin.top + plotH / 2} textAnchor="middle" fontSize="12" fill="#57534e" transform={`rotate(-90 ${margin.left - 40} ${margin.top + plotH / 2})`}>ImageNet Top-1 Accuracy (%)</text>
            <text x={margin.left + plotW / 2} y={height - 10} textAnchor="middle" fontSize="12" fill="#57534e">Number of Parameters (Millions)</text>

            {renderPoints(STANDALONE_MODELS, { fill: '#a8a29e', textFill: '#57534e', fontSize: 10.5, fontWeight: 400, radius: 4, defaultDy: -8 })}

            <path d={linePath(RESNET_SERIES)} fill="none" stroke="#78716c" strokeWidth="1.5" strokeDasharray="2 3" />
            {renderPoints(RESNET_SERIES, { fill: '#78716c', textFill: '#57534e', fontSize: 10.5, fontWeight: 400, radius: 4, defaultDy: -8 })}

            <path d={linePath(NAS_SERIES)} fill="none" stroke="#3b82f6" strokeWidth="2" strokeDasharray="7 4" />
            {renderPoints(NAS_SERIES, { fill: '#3b82f6', textFill: '#1d4ed8', fontSize: 10.5, fontWeight: 500, radius: 4, defaultDy: -9 })}

            <path d={linePath(EFFICIENTNET_SERIES)} fill="none" stroke="#9333ea" strokeWidth="2.5" />
            {renderPoints(EFFICIENTNET_SERIES, { fill: '#9333ea', textFill: '#7e22ce', fontSize: 11, fontWeight: 600, radius: 4.5, defaultDy: -9 })}

            {(() => {
                const b4 = EFFICIENTNET_SERIES.find(p => p.label === 'B4');
                const cx = sx(b4.params) + (b4.labelOffset?.dx ?? 0) / 2;
                const cy = sy(b4.acc) + (b4.labelOffset?.dy ?? 0) / 2;
                return <circle cx={cx} cy={cy} r="24" fill="none" stroke="#dc2626" strokeWidth="2.5" />;
            })()}
        </svg>
    );
};

const interpolateColor = (t) => {
    // light purple -> dark purple
    const stops = [
        { p: 0, c: [250, 245, 255] },
        { p: 0.5, c: [192, 132, 252] },
        { p: 1, c: [88, 28, 135] },
    ];
    let a = stops[0], b = stops[stops.length - 1];
    for (let i = 0; i < stops.length - 1; i++) {
        if (t >= stops[i].p && t <= stops[i + 1].p) { a = stops[i]; b = stops[i + 1]; break; }
    }
    const localT = (t - a.p) / (b.p - a.p || 1);
    const rgb = a.c.map((v, i) => Math.round(v + (b.c[i] - v) * localT));
    return `rgb(${rgb.join(',')})`;
};

const ConfusionMatrixChart = () => {
    const [hover, setHover] = useState(null);
    const n = GENERATORS.length;
    const cell = 27;
    const leftMargin = 195;
    const topMargin = 10;
    const bottomMargin = 175;
    const gridSize = n * cell;
    const width = leftMargin + gridSize + 20;
    const height = topMargin + gridSize + bottomMargin;
    const maxVal = 134;

    return (
        <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-auto font-raleway">
            {GENERATORS.map((rowLabel, r) => {
                const active = hover?.r === r;
                return (
                    <text
                        key={`row-${rowLabel}`}
                        x={leftMargin - 8}
                        y={topMargin + r * cell + cell / 2}
                        textAnchor="end"
                        dominantBaseline="middle"
                        fontSize="10.5"
                        fontWeight={active ? 700 : 400}
                        fill={active ? '#7e22ce' : '#44403c'}
                    >
                        {rowLabel}
                    </text>
                );
            })}
            {GENERATORS.map((colLabel, c) => {
                const active = hover?.c === c;
                return (
                    <text
                        key={`col-${colLabel}`}
                        x={leftMargin + c * cell + cell / 2}
                        y={topMargin + gridSize + 8}
                        textAnchor="end"
                        fontSize="10.5"
                        fontWeight={active ? 700 : 400}
                        fill={active ? '#7e22ce' : '#44403c'}
                        transform={`rotate(-60 ${leftMargin + c * cell + cell / 2} ${topMargin + gridSize + 8})`}
                    >
                        {colLabel}
                    </text>
                );
            })}
            {CONFUSION_MATRIX.map((row, r) => row.map((val, c) => {
                const t = Math.sqrt(val / maxVal);
                const bg = interpolateColor(t);
                const textColor = t > 0.62 ? '#ffffff' : '#3f2a5c';
                return (
                    <g
                        key={`${r}-${c}`}
                        onMouseEnter={() => setHover({ r, c })}
                        onMouseLeave={() => setHover(null)}
                    >
                        <rect
                            x={leftMargin + c * cell}
                            y={topMargin + r * cell}
                            width={cell}
                            height={cell}
                            fill={bg}
                            stroke="#fff"
                            strokeWidth="1"
                        />
                        <text
                            x={leftMargin + c * cell + cell / 2}
                            y={topMargin + r * cell + cell / 2}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fontSize="9.5"
                            fill={textColor}
                        >
                            {val}
                        </text>
                    </g>
                );
            }))}
            {hover && (
                <>
                    <rect x={leftMargin} y={topMargin + hover.r * cell} width={gridSize} height={cell} fill="none" stroke="#7e22ce" strokeWidth="1.5" pointerEvents="none" />
                    <rect x={leftMargin + hover.c * cell} y={topMargin} width={cell} height={gridSize} fill="none" stroke="#7e22ce" strokeWidth="1.5" pointerEvents="none" />
                </>
            )}
            <rect x={leftMargin} y={topMargin} width={gridSize} height={gridSize} fill="none" stroke="#78716c" strokeWidth="1" />
            <text x={20} y={topMargin + gridSize / 2} textAnchor="middle" fontSize="12" fill="#57534e" transform={`rotate(-90 20 ${topMargin + gridSize / 2})`}>True Label</text>
            <text x={leftMargin + gridSize / 2} y={height - 4} textAnchor="middle" fontSize="12" fill="#57534e">Predicted Label</text>
        </svg>
    );
};

const MisclassLollipopView = () => {
    const width = 700, height = 340;
    const margin = { top: 10, right: 50, bottom: 10, left: 150 };
    const plotW = width - margin.left - margin.right;
    const plotH = height - margin.top - margin.bottom;
    const rowH = plotH / MISCLASSIFICATION_BY_ALTERATION.length;
    const xMax = 35;
    const sx = (rate) => (rate / xMax) * plotW;
    return (
        <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-auto font-raleway">
            {[0, 10, 20, 30].map(t => (
                <line key={t} x1={margin.left + sx(t)} x2={margin.left + sx(t)} y1={margin.top} y2={height - margin.bottom} stroke="#e7e5e4" strokeWidth="1" />
            ))}
            {MISCLASSIFICATION_BY_ALTERATION.map((d, i) => {
                const y = margin.top + i * rowH + rowH / 2;
                return (
                    <g key={d.label}>
                        <text x={margin.left - 10} y={y} textAnchor="end" dominantBaseline="middle" fontSize="12" fill="#44403c">{d.label}</text>
                        <line x1={margin.left} x2={margin.left + sx(d.rate)} y1={y} y2={y} stroke="#c4b5fd" strokeWidth="2" />
                        <circle cx={margin.left + sx(d.rate)} cy={y} r="5.5" fill="#9333ea" />
                        <text x={margin.left + sx(d.rate) + 12} y={y} dominantBaseline="middle" fontSize="12" fill="#57534e">{d.rate.toFixed(2)}%</text>
                    </g>
                );
            })}
        </svg>
    );
};

const ImageAttribution = () => {
    const secondaryFontStyle = { fontFamily: "'Raleway', sans-serif" };
    const museoStyle = { fontFamily: "'MuseoModerno', cursive" };
    const tableCellStyle = "px-4 py-2 border border-stone-200 text-[14px] md:text-[15px] font-raleway";

    return (
        <div>
                <SEO
                    title="Synthetic Image Attribution"
                    description="A research project by Lord Crawford and Braden Becker fine-tuning an EfficientNetB4 classifier to identify which AI tool generated a synthetic image, reaching 96.0% validation accuracy across 20 generation tools."
                    path="/imageattribution"
                />
                <div className="text-[4vw] ml-[3.5%] mt-[2%] space-y-[-2vw] invisible title-spacer" aria-hidden="true"><div>Lord</div><div>Crawford</div></div>
                <div className='pb-[6vw] px-[3.5%]'>
                    <div className='mt-[12%] md:mt-[6%] max-w-[860px]'>
                        <div className='flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-14'>
                            <h2 style={museoStyle} className="text-[5.5vw] md:text-[2.6vw] text-purple-600 font-normal leading-[1.05]">
                                Synthetic Image Attribution
                            </h2>
                            <a
                                href="/files/synthetic-image-attribution-report.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-fit bg-purple-600 px-5 py-3 text-white hover:bg-purple-700 text-center font-raleway whitespace-nowrap md:ml-6"
                            >
                                View Paper &rarr;
                            </a>
                        </div>

                        <p className="mt-10 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                            <b>Given a fake image, can you tell which AI made it?</b>
                            <br/><br/>
                            As tools like DALL-E, Stable Diffusion, MidJourney, and Adobe Firefly make synthetic images harder to tell from real ones, most research has focused on detection — is this image fake at all? With Braden Becker, I tackled the narrower question of attribution — given a known synthetic image, determining which specific tool made it — by fine-tuning an EfficientNetB4 classifier on the WILD dataset of 20,000 synthetic facial images spanning 20 generation tools, reaching 96.0% validation accuracy.
                            <br/><br/>
                            We then stress-tested the model against real-world image alterations — compression, cropping, blurring, resizing, rotation — and found no single distortion type meaningfully harder to attribute than another. The more useful finding: training on even lightly altered images substantially improved the model's ability to generalize to heavily altered ones, suggesting attribution models require exposure to noise, not just clean data, to remain reliable under real-world conditions.
                        </p>

                        <p className='mt-10 text-center text-[15px] text-stone-500 font-raleway'>Sample synthetic faces — true generator vs. the model's predicted generator</p>
                        <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
                            <img className="w-full h-auto object-cover" src={require('../photos/imageattribution_face_1_adobe_firefly.png')} alt="Synthetic face — true generator Adobe Firefly, predicted Hotpot AI"/>
                            <img className="w-full h-auto object-cover" src={require('../photos/imageattribution_face_2_stable_cascade.png')} alt="Synthetic face — true generator Stable Cascade, predicted Stable Diffusion XL"/>
                            <img className="w-full h-auto object-cover" src={require('../photos/imageattribution_face_3_hotpot_ai.png')} alt="Synthetic face — true generator Hotpot AI, predicted Stable Diffusion 3.5"/>
                            <img className="w-full h-auto object-cover" src={require('../photos/imageattribution_face_4_flux1.png')} alt="Synthetic face — true generator Flux.1, predicted Freepik"/>
                        </div>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Specifications</h2>
                            <div style={secondaryFontStyle} className="mt-3 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                <p><b>Dates:</b> 2025</p>
                                <p><b>Tools Used:</b> Python, TensorFlow/Keras, EfficientNetB4, NumPy, Pandas, scikit-learn, Matplotlib</p>
                                <p><b>Role:</b> Co-developed with Braden Becker, CS230 (Deep Learning), Stanford</p>
                                <p><b>Links:</b>{' '}
                                    <a href="/files/synthetic-image-attribution-report.pdf" target="_blank" rel="noopener noreferrer" className="underline decoration-purple-500 decoration-[2px] hover:font-semibold">Paper</a>
                                    {', '}
                                    <a href="/files/synthetic-image-attribution-poster.pdf" target="_blank" rel="noopener noreferrer" className="underline decoration-purple-500 decoration-[2px] hover:font-semibold">Poster</a>
                                    {', '}
                                    <a href="https://github.com/lordcrawford/cs230_genaifakes" target="_blank" rel="noopener noreferrer" className="underline decoration-purple-500 decoration-[2px] hover:font-semibold">GitHub</a>
                                </p>
                            </div>
                        </div>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Background &amp; Methods</h2>
                            <p className="mt-3 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                This project builds on WILD, a dataset of 50,000 synthetic facial images spanning 20 modern generation tools — DALL-E, Stable Diffusion, MidJourney, StyleGAN, and others. WILD is split into a closed set, an open set, and a post-processed set, letting us test how well an attribution model handles generators it hasn't seen in training and images that have been altered after the fact.
                            </p>
                            <p className="mt-4 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                We also chose EfficientNetB4 as our base architecture because it offered the best accuracy per parameter of any convolutional network in the literature — matching much larger, more expensive architectures like AmoebaNet-C and SENet at a fraction of the parameter count.
                            </p>
                            <div className="mt-6 max-w-[720px] mx-auto">
                                <EfficientNetChart />
                            </div>
                            <p className='mt-2 text-center text-[13px] text-stone-400 font-raleway'>Recreated from Tan &amp; Le, "EfficientNet: Rethinking Model Scaling for Convolutional Neural Networks" (2019)</p>
                            <p className="mt-6 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                We fine-tuned EfficientNetB4 pretrained on ImageNet — training on frozen base weights first, then unfreezing and training end-to-end at a lower learning rate. We also trained progressively on WILD's Step 1, Step 2, and Step 3 post-processed images, each reflecting how many random transformations were applied, to build robustness to real-world alterations.
                            </p>
                        </div>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Results</h2>

                            <p className="mt-3 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                Fine-tuning the base model — rather than training on frozen ImageNet weights alone — closed most of the gap between training and validation performance:
                            </p>
                            <div className="mt-4 overflow-x-auto flex justify-center">
                                <table className="border-collapse">
                                    <thead>
                                        <tr>
                                            <th className={`${tableCellStyle} text-left bg-stone-50`}>Metric</th>
                                            <th className={`${tableCellStyle} text-left bg-stone-50`}>Frozen Layers</th>
                                            <th className={`${tableCellStyle} text-left bg-purple-50`}>Fine-Tuning</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className={tableCellStyle}>Training Accuracy</td>
                                            <td className={tableCellStyle}>95.61%</td>
                                            <td className={`${tableCellStyle} bg-purple-50`}>99.31%</td>
                                        </tr>
                                        <tr>
                                            <td className={tableCellStyle}>Validation Accuracy</td>
                                            <td className={tableCellStyle}>86.92%</td>
                                            <td className={`${tableCellStyle} bg-purple-50`}>96.00%</td>
                                        </tr>
                                        <tr>
                                            <td className={tableCellStyle}>Training Loss</td>
                                            <td className={tableCellStyle}>0.1854</td>
                                            <td className={`${tableCellStyle} bg-purple-50`}>0.0247</td>
                                        </tr>
                                        <tr>
                                            <td className={tableCellStyle}>Validation Loss</td>
                                            <td className={tableCellStyle}>0.4023</td>
                                            <td className={`${tableCellStyle} bg-purple-50`}>0.1002</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <p className="mt-8 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                Against altered images, misclassification rates stayed within a narrow band regardless of alteration type — no single transformation stood out as significantly harder to attribute:
                            </p>
                            <div className="mt-4 max-w-[650px] mx-auto">
                                <MisclassLollipopView />
                            </div>

                            <p className="mt-8 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                The confusion matrix on distorted images revealed clear outliers — certain generators, like Leonardo AI and Tencent Hunyuan, were far more often confused with one another than with the rest of the field:
                            </p>
                            <p className='mt-6 text-center text-[15px] text-stone-500 font-raleway'>Confusion matrix of generator classes on Step-3 distorted samples</p>
                            <div className="mt-3">
                                <ConfusionMatrixChart />
                            </div>

                            <p className="mt-8 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                Overall, we noticed that our classifier evaluated poorly on highly distorted images (3 transformations applied). We then shifted direction to making our classifier less susceptible to these transformations, by first adding slightly distorted images (Step 1) to our training set. Our results show a substantial improvement.
                            </p>
                            <div className="mt-4 overflow-x-auto flex justify-center">
                                <table className="border-collapse">
                                    <thead>
                                        <tr>
                                            <th className={`${tableCellStyle} text-left bg-stone-50`}>Training Data</th>
                                            <th className={`${tableCellStyle} text-left bg-stone-50`}>Test Data (# of Alterations)</th>
                                            <th className={`${tableCellStyle} text-left bg-stone-50`}>Classification Rate (%)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {CLASSIFICATION_BY_TRAINING.map((row, i) => (
                                            <tr key={i} className={i === CLASSIFICATION_BY_TRAINING.length - 1 ? 'bg-purple-50' : undefined}>
                                                <td className={tableCellStyle}>{row.training}</td>
                                                <td className={tableCellStyle}>{row.alterations}</td>
                                                <td className={tableCellStyle}>{row.rate}%</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Conclusion &amp; Future Work</h2>
                            <p className="mt-3 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                No single distortion type meaningfully hurt attribution accuracy, but certain generators — like Leonardo AI and Tencent Hunyuan — were consistently confused with one another, suggesting their outputs share deeper stylistic "fingerprints" than models that stayed cleanly separated. We also found that lightly altered images generalized surprisingly well to heavily altered ones, showing that a little noise exposure during training goes a long way toward robustness. Future work should dig into what makes certain generative models' outputs converge visually under distortion, and whether that susceptibility can be predicted before ever training a classifier.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

    )
}

export default ImageAttribution
